import React, { Fragment, useState } from 'react';
import { observer } from 'mobx-react';
import ErrorMessage from '../../components/errormessage';
import ThemedSpinner from '../../components/themed/ThemedSpinner';
import { useStores } from '../../hooks/use-stores';
import { useParams } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import AddRemoveList from '../../components/super/add-remove-list';

function TemplateSubjects({ templateId: propTemplateId }) {
    const { superStore } = useStores();
    let { templateId: paramTemplateId } = useParams();
    const templateId = propTemplateId || paramTemplateId;
    const [loadingSubjectId, setLoadingSubjectId] = useState(null);
    const {
        templatesErrorError,
        loadingSubjects,
        subjects,
        loadingTemplateSubjects,
        editingTemplateSubjects,
        addTemplateSubject,
        deleteTemplateSubject,
    } = superStore;

    /*const mapSubjects = async (subjects) => {
        return await subjects.map((item) => {
            item.name = `[${item.episode_number}] ${item.title}`;
        });
    };*/

    if (!templateId || templateId === 'create') {
        return (
            <Grid container direction="row" justify="center" align="center" spacing={2}>
                <Grid item xs={12}>
                    <Typography>Please save the template first before adding subjects.</Typography>
                </Grid>
            </Grid>
        );
    }

    return (
        <Grid
            container
            direction="row"
            justify="center"
            align="center"
            spacing={2}
        >
            {loadingSubjects || loadingTemplateSubjects ? (
                <ThemedSpinner />
            ) : (
                <Fragment>
                    {templatesErrorError && (
                        <Grid item>
                            <ErrorMessage error={templatesErrorError} />
                        </Grid>
                    )}
                    {subjects && (
                        <Fragment>
                            <Grid item xs={12}>
                                <Typography variant="h4" gutterBottom>
                                    Subjects
                                </Typography>
                            </Grid>
                            <Grid item xs={8}>
                                <AddRemoveList
                                    addItem={async (subjectId) => {
                                        setLoadingSubjectId(subjectId);
                                        try {
                                            await addTemplateSubject(
                                                templateId,
                                                subjectId
                                            );
                                            // Optimistically update the observable array
                                            const subject = subjects.find(s => String(s.id || s.subject_id) === String(subjectId));
                                            if (subject && !editingTemplateSubjects.find(s => String(s.subject_id) === String(subjectId))) {
                                                editingTemplateSubjects.push({
                                                    subject_id: subjectId,
                                                    title: subject.title,
                                                    episode_number: subject.episode_number
                                                });
                                            }
                                        } finally {
                                            setLoadingSubjectId(null);
                                        }
                                    }}
                                    removeItem={async (subjectId) => {
                                        setLoadingSubjectId(subjectId);
                                        try {
                                            await deleteTemplateSubject(
                                                templateId,
                                                subjectId
                                            );
                                            // Optimistically update the observable array
                                            const index = editingTemplateSubjects.findIndex(s => String(s.subject_id) === String(subjectId));
                                            if (index !== -1) {
                                                editingTemplateSubjects.splice(index, 1);
                                            }
                                        } finally {
                                            setLoadingSubjectId(null);
                                        }
                                    }}
                                    itemList={subjects.map((item) => {
                                        const name = `[${item.episode_number}] ${item.title}`;
                                        // Ensure subject_id field exists for idColumn matching
                                        return { ...item, name, subject_id: item.subject_id || item.id };
                                    })}
                                    activeItemList={editingTemplateSubjects || []}
                                    idColumn={'subject_id'}
                                    nameColumn={'name'}
                                    isItemLoading={(subjectId) => loadingSubjectId === String(subjectId)}
                                />
                            </Grid>
                        </Fragment>
                    )}
                </Fragment>
            )}
        </Grid>
    );
}

export default observer(TemplateSubjects);
